module.exports = __webpack_public_path__ + "img/star9-10.79d82941.svg";